import api from '../utils/api'
import { API_ROOT } from '../constants'

// Both calls carry the authorization request's query string exactly as the server sent it here
export const getConsent = (search) => api.get(`${API_ROOT}/oauth2/consent${search}`)

export const decideConsent = (search, approve) => api.post(`${API_ROOT}/oauth2/consent${search}`, { approve })
